(function($) {
    const API = 'https://rnd.mypubs.ru/api.php';
    const Command = {
        RATING: 'rating',
        LOAD: 'load',
        ADD: 'add',
        DELETE: 'delete'
    };
    const Error = {
        ACCESS_DENIED: -1,
        PARAM_FAIL: -2,
        NOT_FOUND: -3,
        BANNED: -4,
        INVALID_EMAIL: -5,
        INVALID_NAME: -6,
        EMPTY_CONTENT: -7,
        TIMEOUT: -8,
        LARGE_REVIEW: -9,
        ALREADY_EXISTS: -10
    };
    var debug = false;
    var fp;
    var formatter = new Intl.DateTimeFormat("ru", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    });
    loadUrlReviews = function() {
        var url = location.href.replace(location.hash, "");
        var container = $('#reviews');
        var loader = $('.items-loading');
        loader.show();
        $.post(API, {
            url,
            cmd: Command.LOAD
        }).done(function(data) {
            if (debug) console.log(data);
            if (data < 0) {
                showError(data);
                return;
            }
            var list = JSON.parse(data);
            if (list.length > 0) {
                addAnswers(list);
                addConfirms();
            }
        }).always(function() {
            loader.hide();
        });
    };
    setFP = function(data) {
        fp = data;
    };
    setDebug = function(data) {
        debug = data;
    };
    function confirmDelete(id) {
        var container = $(`#review-${id}`).find('.review-delete');
        container.html('<a href="#" id="do-delete">\u0423\u0434\u0430\u043B\u0438\u0442\u044C</a> <a href="#" id="cancel-delete">\u041E\u0442\u043C\u0435\u043D\u0430</a>');
        container.find('#do-delete').on('click', function() {
            deleteReview(id);
            return false;
        });
        container.find('#cancel-delete').on('click', function() {
            container.html('<a href="#" class="confirm-delete"><i class="fa-solid fa-trash-can"></i></a>');
            addConfirms();
            return false;
        });
    }
    function deleteReview(id) {
        var url = location.href.replace(location.hash, "");
        var data = {
            id,
            fp
        };
        $.post(API, {
            cmd: Command.DELETE,
            url,
            data
        }).done(function(data) {
            if (debug) console.log(data);
            if (data < 0) {
                showError(data);
                return;
            }
            var article = $(`#review-${id}`);
            article.find('.review-delete').hide();
            var body = article.find('p');
            body.html("<i>\u041E\u0442\u0437\u044B\u0432 \u0443\u0434\u0430\u043B\u0451\u043D</i>");
        }).fail(function(e) {
            var info = $(`<div class="alert-error"><strong>\u{41E}\u{428}\u{418}\u{411}\u{41A}\u{410}:</strong> \u{43D}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43E}\u{442}\u{437}\u{44B}\u{432}</div>`);
            $('#reviews').append(info);
            info.fadeOut(3500).queue(function() {
                $(this).remove();
            });
        });
    }
    function addReview(comment, author, email, rating) {
        var url = location.href.replace(location.hash, "");
        var data = {
            comment,
            author,
            email,
            rating,
            fp
        };
        $.post(API, {
            cmd: Command.ADD,
            url,
            data
        }).done(function(data) {
            if (debug) console.log(data);
            if (data < 0) {
                showError(data);
                return;
            }
            $('#review-text').val('');
            generateReview(JSON.parse(data));
            resetForm();
            addConfirms();
        }).fail(function(e) {
            var info = $(`<div class="alert-error"><strong>\u{41E}\u{428}\u{418}\u{411}\u{41A}\u{410}:</strong> \u{43D}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43E}\u{442}\u{437}\u{44B}\u{432}</div>`);
            $('#reviews').append(info);
            info.fadeOut(3500).queue(function() {
                $(this).remove();
            });
        });
    }
    function showError(code) {
        var message;
        switch(Number(code)){
            case Error.ACCESS_DENIED:
                message = "\u0414\u043E\u0441\u0442\u0443\u043F \u0437\u0430\u043F\u0440\u0435\u0449\u0451\u043D";
                break;
            case Error.PARAM_FAIL:
                message = "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B";
                break;
            case Error.NOT_FOUND:
                message = "\u041E\u0442\u0437\u044B\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D";
                break;
            case Error.BANNED:
                message = "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0432\u0442\u043E\u0440\u0443 \u0441\u0430\u0439\u0442\u0430";
                break;
            case Error.INVALID_EMAIL:
                message = "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u044D\u043B. \u043F\u043E\u0447\u0442\u0430";
                break;
            case Error.INVALID_NAME:
                message = "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0435 \u0438\u043C\u044F";
                break;
            case Error.EMPTY_CONTENT:
                message = "\u041F\u0443\u0441\u0442\u043E\u0435 \u043F\u043E\u043B\u0435 \u0432\u0432\u043E\u0434\u0430";
                break;
            case Error.TIMEOUT:
                message = "\u0412\u0440\u0435\u043C\u044F \u043D\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0432\u044B\u0448\u043B\u043E";
                break;
            case Error.LARGE_REVIEW:
                message = "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0434\u043B\u0438\u043D\u043D\u044B\u0439 \u043E\u0442\u0437\u044B\u0432";
                break;
            case Error.ALREADY_EXISTS:
                message = "\u0412\u044B \u0443\u0436\u0435 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u043B\u0438 \u043E\u0442\u0437\u044B\u0432 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044F, \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044F \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u0430";
                break;
            default:
                message = `\u{41A}\u{43E}\u{434} (${code})`;
                break;
        }
        var info = $(`<div class="alert-error"><strong>\u{41E}\u{428}\u{418}\u{411}\u{41A}\u{410}:</strong> ${message}</div>`);
        $('#reviews').append(info);
        info.fadeOut(3500).queue(function() {
            $(this).remove();
        });
    }
    function resetForm() {
        $('#review-text').val('');
        var cookies = $('#review-save-email').prop('checked');
        if (!cookies) {
            $('#review-name').val('');
            $('#review-email').val('');
        }
    }
    function addForm() {
        $('#review-form').on('submit', function(e) {
            e.preventDefault();
            var comment = $('#review-text').val().trim();
            var author = $('#review-name').val().trim();
            var email = $('#review-email').val().trim();
            var rating = $('#review-rating').val();
            var cookies = $('#review-save-email').prop('checked');
            if (!validate(comment, author, email)) return;
            if (cookies) {
                var age = {
                    'max-age': '604800'
                };
                setCookie('author', author, age);
                setCookie('email', email, age);
            }
            addReview(comment, author, email, rating);
            addConfirms();
        });
        ThumbmarkJS.getFingerprint().then(function(fingerprint) {
            fp = fingerprint;
        });
    }
    function addConfirms() {
        $('.confirm-delete').off('click');
        $('.confirm-delete').on('click', function() {
            var article = $(this).parent().parent();
            var id = article.attr('id').split('-')[1];
            confirmDelete(id);
            return false;
        });
    }
    function validate(comment, author, email) {
        var errors = 0;
        $('#review-text').removeClass('is-invalid');
        $('#review-name').removeClass('is-invalid');
        $('#review-email').removeClass('is-invalid');
        if (comment.length === 0) {
            $('#review-text').addClass('is-invalid');
            errors++;
        }
        if (author.length === 0) {
            $('#review-name').addClass('is-invalid');
            errors++;
        }
        if (email.length === 0) {
            $('#review-email').addClass('is-invalid');
            errors++;
        }
        return errors === 0;
    }
    function addAuthor() {
        var author = getCookie('author');
        var email = getCookie('email');
        if (author) $('#review-name').val(author);
        if (email) $('#review-email').val(email);
        if (author || email) $('#review-save-email').prop('checked', true);
    }
    function addAnswers(list) {
        var parent = $('#reviews');
        list.forEach((item)=>{
            if (item.body.length > 0) generateReview(item);
        });
    }
    function pad(n) {
        return `${Math.floor(Math.abs(n))}`.padStart(2, '0');
    }
    function getTimezoneOffset(date) {
        var offset = -date.getTimezoneOffset();
        var diff = offset >= 0 ? '+' : '-';
        return diff + pad(offset / 60) + ':' + pad(offset % 60);
    }
    function toISOStringWithTimezone(date) {
        return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds()) + getTimezoneOffset(date);
    }
    function generateReview(comment) {
        var date = new Date(comment.date * 1000);
        var url = location.href.replace(location.hash, "");
        var article = $(`<article class="review-item" id="review-${comment.id}"></article>`);
        var header = $(`<div class="review-head"></div>`);
        var author = $(`<span class="review-author">${comment.name}</span>`);
        var score = $(`<span class="review-score">${window.mypubs.stars(comment.rating)} ${comment.rating.toFixed(1)}</span>`);
        var text = $(`<p class="muted-text mb-0">${comment.body}</p>`);
        var trash = $(`<span class="review-delete"><a href="#" class="confirm-delete"><i class="fa-solid fa-trash-can"></i></a></span>`);
        header.append(author);
        header.append(score);
        var diff = (Date.now() - date) / 1000;
        if (diff <= DeletePeriod && comment.body.length > 0) {
            article.append(trash);
            trash.delay(DeletePeriod * 1000).queue(function() {
                $(this).remove();
            });
        }
        article.append(header);
        article.append(text);
        $('#reviews').append(article);
    }
    function plural(forms, count) {
        let index;
        if (count % 10 === 1 && count % 100 !== 11) index = 0;
        else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) index = 1;
        else index = 2;
        return forms[index] || '';
    }
    var container = $('#reviews');
    if (container) {
        loadUrlReviews();
        addForm();
        addAuthor();
    }
})(jQuery);

//# sourceMappingURL=reviews.172e0820.js.map
